export const optionDiscarded = [
    "Es cliente activo",
    "Fue cliente (Mal Historial)",
    "No se logró contacto por ningún medio",
    "Ya no le interesa",
    "Teléfono coincide con otro prospecto",
    "Interesado en crédito individual",
    "En zona de riesgo",
    "Datos incorrectos",
    "No hay sucursal cercana",
    "No cumple con la edad",
    "No cumple con antigüedad de negocio",
    "Lead masculino (NA)",
]